import React from 'react'
import {Button, Divider, message, Modal, Popconfirm} from "antd";
import { post } from '../../axios';
import { API_salesroom_findPage, API_salesroom_delete } from '../../axios/config';
import TableDOM from '../../components/Table';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import SalesroomDetail from "./detail";
import AuthButton from "../../components/AuthButton/AuthButton";
import JrApiLog from "../Other/JrApiLog";
import {syncStatusIsMap} from "../../axios/dictionaries";
import {handleExportParams, isPlatform} from "../../utils";


class SalesroomList extends React.Component{
  state = {
    dataList: [],
    dataListLoading: false,
    dataListTotal: 0,
    queryData: {
      keyword:'',
      syncStatus:'',
      buildingName:'',
      shortName:'',
      pageSize: 10
    },
    pagination: { current:1, pageSize: 10 }
  }
  componentDidMount() {
    this.postSalesroomList()
  }
  postSalesroomDelete(id) {
    return post({ url: API_salesroom_delete  +'?id=' + id }).then(() => {
      message.success('删除成功')
    }).catch(e => {
      message.error(e.message)
    })
  }
  postSalesroomList() {
    const params = {...this.state.queryData, ...this.state.pagination}
    this.setState({  dataListLoading: true })
    post({ url: API_salesroom_findPage, data: params }).then(res => {
      this.setState(state => {
        state.dataList = res.records
        state.dataListTotal = res.total
        state.dataListLoading = false,
        state.pagination.current = res.current
        return state
      })
    }).catch(err => {
      this.setState({ dataListLoading: false });
    })
  }
  handleSearch(e) {
    this.setState(state => {
      state.queryData.keyword = e.keyword
      state.queryData.syncStatus = e.syncStatus
      state.queryData.buildingName=e.buildingName
      state.queryData.shortName=e.shortName
      state.pagination.current = 1
      return state
    },() => {
      this.postSalesroomList()
    })
  }

  handlePageChange(e) {
    this.setState(state => {
      state.pagination.current = e.current
      return state
    },() => {
      this.postSalesroomList()
    })
  }

  handleEdit(id) {
    this.SalesroomDetailRef.open(id).then(() =>{
      this.postSalesroomList()
    })
  }
  handleJrApiLogInfo(tableName,id) {
    this.jrApiLogRef.open(tableName,id);
  }

  handleDelete(id) {
    this.postSalesroomDelete(id).then(() =>{
      this.postSalesroomList()
    })
  }
  render(){

    const columns = [
      { title: '所属楼栋', dataIndex: 'buildingName',width: 250, fixed: 'left'},
      { title: '门店名称', dataIndex: 'projectName' ,width: 230,fixed: 'left'},
      { title: '联系电话', dataIndex: 'serviceTel' },
      // {
      //   title: '同步状态 | 建融Id',
      //   dataIndex: 'name33',
      //   render(text, record, index) {
      //     return <span>
      //           <div>{record.jrProjectId ? "同步成功" : "未同步"}</div>
      //       {
      //         record.jrProjectId
      //             ? <React.Fragment>
      //               <div>{record.jrProjectId ? record.jrProjectId : ''}</div>
      //             </React.Fragment>
      //             : null
      //       }
      //       </span>
      //   }
      // },

      { title: '门店封面', dataIndex: 'coverPicture', render: (text) => {
        return <img src={text} style={{width:30, height:30}} alt="" />
      }},
      {
        title: '商户简称',
        dataIndex: 'shortName'
      },
      { title: '操作', dataIndex: 'action',width: 200, fixed: 'right', render: (_,records) => [
          <AuthButton authkey="l-1-3">
        <a onClick={() => this.handleEdit(records.id)}>编辑</a>
          </AuthButton>,
          // <Divider type="vertical" />,
          // <AuthButton authkey="l-1-5">
          //   <a onClick={() => this.handleJrApiLogInfo("ccbProject",records.id)}>建融日志</a>
          // </AuthButton>
          //   ,
        <Divider type="vertical" />,
          <AuthButton authkey="l-1-4">
            <Popconfirm title="确认删除吗" onConfirm={this.handleDelete.bind(this,records.id)}>
              <a>删除</a>
            </Popconfirm>
          </AuthButton>

      ] }
    ]

    const searchData = () => {
      let data = [
        {
          tagName: 'Select',
          formConfig: { name: 'syncStatus' },
          attribute: { placeholder: '请选择同步状态', style: { width: "130px" } },
          optionData: [{ title: '全部', value: '' }].concat(syncStatusIsMap), //.concat(dicHouseStatus)
          notResult: '',
        },
        {
          tagName: 'Input',
          formConfig: { name: 'shortName' },
          attribute: { placeholder: '输入商户名称', style: { width: '150px' } },
        },
        {
          tagName: 'Input',
          formConfig: { name: 'buildingName' },
          attribute: { placeholder: '输入小区楼栋', style: { width: '150px' } },
        },
        {
              tagName: 'InputTip',
              formConfig: { name: 'keyword' },
              attribute: { placeholder: '请输入关键字', style: { width: '130px' } },
            title: `在门店名称、建融门店Id内模糊查询`
          },
      ];

      data = data.filter(e => {
        if(isPlatform()){
          return true;
        }
        if (e.formConfig.name === 'shortName') {
          return false;
        }
        return true;
      });

      return data;
  };

    return (
      <PageWrap loading={this.state.dataListLoading}>
        <div className="search-wrapper ">
          <div className="search-btn-list" >
            <AuthButton authkey="l-1-2">
              <Button icon="plus" type="primary" onClick={() => this.handleEdit()}>新增</Button>
            </AuthButton>
          </div>
          <SuperForm
            onRef={ref => this.superFormRef = ref}
            data={searchData()}
            sumbit={this.handleSearch.bind(this)}
            addParams={'current'}
          />
        </div>

        <TableDOM 
          loading={this.state.dataListLoading}
          total={this.state.dataListTotal}
          current={this.state.pagination.current}
          onChange={this.handlePageChange.bind(this)}
          columns={columns}
          data={this.state.dataList}
          pagination={this.state.pagination}
          scroll={{x: 1500}}
        />

        <SalesroomDetail wrappedComponentRef={ ref=> this.SalesroomDetailRef = ref } />


          <JrApiLog ref={ref=>{
            this.jrApiLogRef=ref;
          }}/>

      </PageWrap>
    )
  }
}



export default SalesroomList


// WEBPACK FOOTER //
// ./src/page/Salesroom/index.jsx